import {
  moonlight,
  SimplePrettyTerminalTransport,
} from "@loglayer/transport-simple-pretty-terminal";
import { ConsoleTransport, LogLayer, type ILogLayer } from "loglayer";
import { serializeError } from "serialize-error";

export function createLogger(): ILogLayer {
  return new LogLayer({
    errorSerializer: serializeError,
    transport: [
      new ConsoleTransport({
        logger: console,
        enabled: !import.meta.env.DEV,
      }),
      new SimplePrettyTerminalTransport({
        enabled: import.meta.env.DEV,
        runtime: import.meta.env.SSR ? "node" : "browser",
        viewMode: "inline",
        theme: moonlight,
      }),
    ],
  });
}

export type Logger = ReturnType<typeof createLogger>;
export const defaultLogger = createLogger();

let logProvider: () => ILogLayer = () => defaultLogger;

export function setLogProvider(provider: () => ILogLayer) {
  logProvider = provider;
}

export function getLogger() {
  return logProvider();
}
